import { ServicePricingSummary } from "../../../../Partials/PricingHighlight/ServicePricingSummary.csharp";

export const pricingSummaryInitialState: ServicePricingSummary = {
  serviceName: "",
  id: 0,
  variantId: 0,
  basePriceLabel: "",
  endPriceLabel: "",
  weekendPriceLabelInBooking: "",
  eveningPriceLabelInBooking: "",
  eveningWeekendPriceHeading: "",
  eveningWeekendSamePriceLabel: "",
  eveningPriceReservationLabel: "",
  showWarningAboutHigherPrice: false,
  isFriday: false,
  eveningPriceLabel: "",
  weekendPriceLabel: "",
  basePrice: 0,
  showWeekendEveningPrices: true,
  baseFees: [],
  additionalFeesLabel: "",
  additionalFees: [],
  membersPrice: 0,
  listWithoutPrice: false,
  listWithoutPriceLabel: "",
  holidayDates: [],
  eveningAddition: 0,
  weekendHolidayAddition: 0,
  isEvening: false,
  isWeekendOrHoliday: false,
  eveningWeekendDiscountPriceHeading: "",
  highlightPriceRowOnHover: false,
  priceListFees: {
    fees: [],
    priceListLabel: "",
    eveningPriceListHeading: "",
    eveningPriceListHeadingWithCampaign: "",
    eveningWeekendPriceListHeading: "",
    eveningWeekendPriceListHeadingWithCampaign: "",
    showEveningWeekendPrices: false,
    weekendPriceListHeading: "",
    weekendPriceLstHeadingWithCampaign: "",
  },
};
